<template>

    <LoopItemPanel title="Slide">

        <div class="shop::canvas-blocks-shop-categories-LoopItemPanel">

            <div class="m-5">

                <div class="text-gray-600 mb-1 label2">Categorie selecteren</div>

                <treeselect
                    ref="treeselect"
                    v-model="loopItem.category"
                    :options="treeOptions"
                    clearAllText="Verwijder allemaal"
                    clearValueText="Verwijder"
                    loadingText="Laden..."
                    noChildrenText="Geen categorieeën"
                    noOptionsText="Geen keuzes..."
                    noResultsText="Geen keuzes..."
                    placeholder="Kies categorie..."
                    retryText="Probeer opnieuw"
                    searchPromptText="Typ om te zoeken"
                    :closeOnSelect="true"
                    @input="this.save"
                    :multiple="false"
                    search-nested
                >

                    <template slot="option-label" slot-scope="{ node }">

                        <div
                            class="text-sm"
                            :class="{
                                'py-1': true,
                            }"
                        >
                            {{ node.raw.label }}
                        </div>

                    </template>

                    <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>

                </treeselect>

            </div>

        </div>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/owlCarousel/LoopItemPanel";
import Treeselect from '@riophae/vue-treeselect';
import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
        Treeselect,
    },

    data() {
        return {
            categories: null,
        };
    },

    async mounted()
    {
        await this.loadData();
    },

    methods: {

        async loadData() {
            // Load artists.
            this.categories = (await axios.get('/admin/modules/shop/categories/get-tree')).data;
        },

        mapItem(category, children) {
            // Abort due to no items? Otherwise Treeselect will show empty subtree.
            if (!children.length)
                return undefined;

            return _.map(children, category => {
                return {
                    id: category.id,
                    label: category.name.nl, // TODO Medium: support search & multi language.
                    children: this.mapItem( category, category.children ),
                };
            });
        },

    },

    computed: {

        treeOptions() {

            // Abort due to empty?
            if (this.categories === null)
                return [];

            // Map website pages.
            return _.map(this.categories, category => {
                return {
                    id: category.id,
                    label: category.name.nl, // TODO Medium: Add language support?
                    children: this.mapItem(category, category.children),
                };
            });
        },

    }

}
</script>

<style lang="scss" scoped>

.shop\:\:canvas-blocks-shop-categories-LoopItemPanel {

    &.loading {

        .vue-treeselect {
            pointer-events: none;
        }

        ::v-deep .vue-treeselect__placeholder {
            padding-left: 33px !important;
        }

    }

    ::v-deep {

        .vue-treeselect__single-value,
        .vue-treeselect__placeholder {
            @apply px-2;
            padding-top: 0.5rem;
        }

        .vue-treeselect__single-value,
        .vue-treeselect__placeholder,
        input {
            @apply text-sm;
            box-shadow: none;
            color: #333 !important;
        }

        .vue-treeselect__option--selected {
            background: white !important;
        }

        .vue-treeselect__control {
            @apply border border-gray-300;
            border: 1px solid rgba(209, 213, 219, var(--tw-border-opacity));
            height: 38px;
        }

        .vue-treeselect__menu {
            top: 100%;
            bottom: auto;
        }

    }

}

</style>
